import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../components/ui";
import { EXTEND_CONSIGNMENT as extendConsignmentMutation } from "../../../../graphql/mutation/Consignment";

const ExtendConsignment = ({ closeModal, consignment }) => {
  const navigate = useNavigate();
  const [extendConsignment, { loading, error }] = useMutation(
    extendConsignmentMutation(),
  );

  const handleCreate = () => {
    extendConsignment({
      variables: {
        input: { id: consignment.id },
      },
      update: (cache, { data }) => {
        const { extendConsignment: { consignment, success } = {} } = data || {};
        if (success) {
          navigate(`${consignment?.id}/form`);
        }
      },
    });
  };

  return (
    <div className="mt-4 flex">
      {error && <div className="font-bold">{error.message}</div>}
      <Button
        className="mr-3"
        label={"Cancel"}
        onClick={() => {
          closeModal();
        }}
      />
      <Button
        label={loading ? "Creating" : "Create"}
        action="primary"
        disabled={loading}
        onClick={handleCreate}
      />
    </div>
  );
};

export default ExtendConsignment;
